import { toast } from 'sonner';
import { useState } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useTranslation } from 'react-i18next';

import { Popover, Flex, Box, Text, TextArea, Heading } from '@radix-ui/themes';

import { ChatCenteredIcon } from '@/components/icons';
import Button from '@/components/Button';

export default function Feedback() {
  const posthog = usePostHog();
  const [feedback, setFeedback] = useState('');
  const { t } = useTranslation();

  if (!window.POSTHOG_FEEDBACK_SURVEY_ID) return;

  const handleSubmit = () => {
    posthog.capture('survey sent', {
      $survey_id: window.POSTHOG_FEEDBACK_SURVEY_ID,
      $survey_response: feedback,
    });

    toast.success(t('feedback.success'));

    setFeedback('');
  };

  return (
    <Popover.Root>
      <Popover.Trigger>
        <Button variant="soft" size="3" radius="full">
          <ChatCenteredIcon width="16" height="16" />
          <Text className="hidden xl:inline">{t('common.feedback')}</Text>
        </Button>
      </Popover.Trigger>

      <Popover.Content className="w-60 sm:w-[360px]">
        <Flex gap="3" direction="column">
          <Heading size="3">{t('common.feedback')}</Heading>

          <Text size="2" color="gray">
            {t('feedback.description')}
          </Text>

          <Box flexGrow="1">
            <TextArea
              name="feedback"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder={t('feedback.placeholder')}
              style={{ height: 80 }}
            />

            <Flex gap="3" mt="3">
              <Popover.Close>
                <Button onClick={handleSubmit} disabled={!feedback.length}>
                  {t('common.submit')}
                </Button>
              </Popover.Close>
            </Flex>
          </Box>
        </Flex>
      </Popover.Content>
    </Popover.Root>
  );
}
